import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import createMiddleware from './middleware/clientMiddleware';
import createRouterMiddleware from './middleware/routerMiddleware';
// import { persistStore, autoRehydrate } from 'redux-persist';

import logger from 'redux-logger'

import reduxCatch from 'redux-catch';

import { middleware as idleMiddleware } from '../components/redux-idle-monitor'
import { loadingBarMiddleware } from 'react-redux-loading-bar'



function errorHandler(error, getState, lastAction, dispatch) {
  console.error(error);
  console.debug('current state', getState());
  console.debug('last action was', lastAction);
  // optionally dispatch an action due to the error using the dispatch parameter
}


export default function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  const reduxRouterMiddleware = createRouterMiddleware(history);

  const middleware = [reduxCatch(errorHandler), createMiddleware(client), reduxRouterMiddleware, idleMiddleware];

  let finalCreateStore;
  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
    const { persistState } = require('redux-devtools');
    const DevToolsModule = require('../containers/DevTools/DevTools');
    const DevTools = DevToolsModule.default || DevToolsModule;
    finalCreateStore = compose(
      applyMiddleware(...middleware),
      applyMiddleware(logger),
      //applyMiddleware(loadingBarMiddleware()),
      //window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(),
      persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
    )(_createStore);
  } else {
    finalCreateStore = compose(
      applyMiddleware(...middleware)
    )(_createStore);
  }

  const reducerModule = require('./modules/reducer');
  const reducer = reducerModule.default || reducerModule;
  const store = finalCreateStore(reducer, data);

  // redux-persist désactivé - les filtres supervision sont gérés via sessionStorage direct
  // if (typeof window !== 'undefined') {
  //   const persistor = persistStore(store, {
  //     whitelist: ['supervision'],
  //     keyPrefix: 'sts:'
  //   });
  //   store.persistor = persistor;
  // }

  /*if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer'));
    });
  }
   */
  return store;
}
